<template lang="html">

  <!--

  <div v-bind:id="id" >

    <component class="block" v-if="config.actionid" v-bind:is="'bulmaActions'" v-bind:id="config.actionid"></component>

    <nav class="panel" v-for="(r, index) in config.rows" v-bind:key="r.id">

      <p class="panel-heading" v-if="r.title" style="padding: 0.5em; font-size: 1em;">
        <button v-on:click="tabClick(index, !r.opened)">
          <span class="icon">
            <i v-if="r.opened" class="fas fa-chevron-down"></i>
            <i v-if="!r.opened" class="fas fa-chevron-left"></i>
          </span>
        </button>
        {{ r.title }}
      </p>

      <div class="panel-block" v-if="r.opened">
        <component v-bind:is="r.type" v-bind:id="r.id"></component>
      </div>
      
    </nav>

    <component class="block" v-if="config.actionid" v-bind:is="'bulmaActions'" v-bind:id="config.actionid"></component>

  </div>
  -->

  <div>
    <!-- <bulmaSectionsProps 
      v-if="showModal"
      v-bind:data="config"
      v-bind:id="id"
      v-on:close="closeModal"
    ></bulmaSectionsProps> -->
    <article class="message" v-bind:id="id" v-if="this.config">
      
      <!-- <button class="button" v-on:click="showModal=!showModal">show section props</button> -->
      <component class="block" v-if="config.actionid" v-bind:is="'bulmaActions'" v-bind:id="config.actionid"></component>

      <div v-for="(r, index) in config.rows" v-bind:key="r.id" class="pb-4" v-bind:class="{'block': index==(config.rows.length-1) }" >
        
        <component v-if="r.type != 'bulmaFieldSet2'" class="block" :is="r.type" :id="r.id"></component>
        
        <div v-else-if="isComponentVisible(r.id)">
          <div v-if="r.id || r.type">
            <div class="message-header" v-if="r.title">
              <p>{{ r.title }}</p>

              <button v-on:click="tabClick(index, !r.opened)">
                <span class="icon">
                  <i v-if="r.opened" class="fas fa-chevron-down"></i>
                  <i v-if="!r.opened" class="fas fa-chevron-left"></i>
                </span>
              </button>
            </div>

            <div class="message-body" v-if="r.opened" v-bind:style="{'border-left': !r.title?'0px':'', 'padding-top': !r.title?'0px':''}">
              <component v-bind:is="r.type" v-bind:id="r.id"></component>
              <creator v-bind:index="index" v-bind:editButton="true" @create-component="addComponent"></creator>
            </div>
          </div>
        </div>
        <!-- v-if="!r.id && !r.type" -->
          
          <!-- v-if="r.type && isAdmin() && getEditProps" --> <!-- v-bind:oldid="r.id" v-bind:fatherId="id" -->
      
          

      </div>

        <component class="block" v-if="config.actionid" v-bind:is="'bulmaActions'" v-bind:id="config.actionid"></component>

    </article>
    <div v-if="showScanner" class="scanner-overlay">
      <div class="scanner-box">
        <button class="button is-small is-light close-btn" @click="showScanner=false">
          <span class="icon is-small"><i class="fas fa-times"></i></span>
        </button>
        <button class="button is-small is-link capture-btn" @click="capturePic">
          <span class="icon is-small"><i class="fas fa-camera"></i></span>
          <span>Scatta</span>
        </button>
        <camera ref="cam" @barcode-scanned="onScanned" @picture-captured="onPicture" :showCapture="false" />
      </div>
    </div>
    <div v-if="!this.config">
      <button class="button" v-on:click="showModal=!showModal">
        initialize section
      </button>
    </div>
  </div>
</template>

<script>
import bulmaSectionsProps from '../components/bulma_sectionsprops.vue'
import creator from './creator.vue'
import camera from './bulma_camera.vue'
export default {
  name: 'bulmaSections',
  components: {
    bulmaSectionsProps,
    creator,
    camera

  },
  computed: {
    config: function() {
      return this.$store.getters.getObject(this.id).data;
    },
  },
  props: {
    id: String,
  },
  data() {
    return {
      showModal: false,
      showScanner: false,
    }
  },
  mounted: function() {
  },
  async created() {
    // Ascolta l'evento globale emesso dalle azioni per aprire lo scanner
    this.$root.$on('open-barcode-scanner', this.openScanner);
  },
  beforeDestroy() {
    this.$root.$off('open-barcode-scanner', this.openScanner);
  },
  methods: {
    tabClick: function(tabindex, opened) {
      var c=this.config;
      c.rows[tabindex].opened=opened;
      var payload={ id:this.id, cfg:{ id:this.id, type:this.type, data:c} }      
      this.$store.commit('SET_CONFIG', payload);
    },
    closeModal(){
      this.showModal = false;
    },
    async addComponent(data) {
      
      if (!data.component) {
        console.warn("addComponent: 'component' è undefined o nullo");
        return;
      }
      
      
      // Trova l'indice dell'elemento da rimuovere solo se `component.oldid` esiste
      //const index = data.oldid ? this.config.rows.findIndex(item => item.id === data.oldid) : -1;
      // if(data.index >=0){
      //   console.log("sono giusto", this.config.rows);
      //   data.component.title = this.config.rows[data.index].title;
      //   data.component.opened = this.config.rows[data.index].opened;
      // }
      
      //cerco vecchio componente

      let localRows;
      if (data.index>=0) {

        localRows = this.config.rows.filter((_, index) => index !== data.index);
      } else {
      
        localRows = [...this.config.rows];
      }
      
      
      //let savedNotes=component.notes;
      
      //inserisco nuovo componente
      console.log("row component", data);
      
      if (data.index >=0) {
        console.log("sono giusto", this.config.rows);
        data.component.title = this.config.rows[data.index].title;
        data.component.opened = this.config.rows[data.index].opened;
        localRows.splice(data.index, 0, data.component);  
      } else {
        data.component.title= "new section";
        data.component.opened="false";
        localRows.push(data.component); 
      }
      
      
      const props= { 
        
        rows:localRows 
      };
      
        
      
      
      console.log("new props: ", data.component);
      await this.$store.dispatch('createObject', { id: data.component.id, type: data.component.type});
      
      console.log("new rows", localRows);
      await this.$store.dispatch('setObjectDB', { id: this.id, data: props });
      
      let cfg = this.config;
      cfg.rows = localRows;
      
      
      // nuovo oggetto
      this.$store.commit('SET_CONFIG_OBJECT', { id: data.component.id, type: data.component.type });
      
      // modifica bulmaRows
      this.$store.commit('SET_CONFIG_OBJECT', { id: this.id, type: "bulmaRows", data: cfg });
    },
    isAdmin(){
      return this.$store.getters.isAdmin;
    },
    switchEditMode(){
      var newEditStatis = !this.$store.getters.getEditMode(this.id)
      var payload={ id: this.id, editmode: newEditStatis};
      this.$store.commit('SET_EDITMODE', payload);
    },
    getEditProps(){
      return this.$store.getters.getEditProps;
    },
    openScanner() {
      this.showScanner = true;
    },
    onScanned(payload) {
      // stampa e inoltra il risultato a livello globale e chiudi
      try {
        const msg = `Scanned: ${payload.text} | format: ${payload.format} | bytes: ${payload.rawBytesLength}`
        console.log('onScanned ->', payload)
        alert(msg)
      } catch (e) {}
      this.$root.$emit('barcode-scanned', payload);
      this.showScanner = false;
    },
    capturePic() {
      const cam = this.$refs.cam
      if (cam && typeof cam.captureImage === 'function') cam.captureImage()
    },
    onPicture({ picture }) {
      // inoltra l'immagine al livello superiore per decodifica server/later
      console.log('picture captured (base64 length):', picture && picture.length)
      this.$root.$emit('barcode-picture', { picture })
      this.decodeBase64AndPrint(picture)
      this.showScanner = false
    },
    async decodeBase64AndPrint(dataUrl) {
      try {
        const { BrowserMultiFormatReader, BarcodeFormat, DecodeHintType } = await import('@zxing/library')
        const hints = new Map()
        hints.set(DecodeHintType.POSSIBLE_FORMATS, [
          BarcodeFormat.EAN_13,
          BarcodeFormat.CODE_128,
          BarcodeFormat.QR_CODE,
          BarcodeFormat.EAN_8,
          BarcodeFormat.UPC_E,
          BarcodeFormat.UPC_A,
          BarcodeFormat.CODE_39,
          BarcodeFormat.ITF
        ])
        hints.set(DecodeHintType.TRY_HARDER, true)

        const reader = new BrowserMultiFormatReader(hints)
        const result = await reader.decodeFromImageUrl(dataUrl)
        const rawBytes = (result.getRawBytes && result.getRawBytes()) || null
        const payload = {
          text: result.getText && result.getText(),
          format: result.getBarcodeFormat && result.getBarcodeFormat(),
          rawBytesLength: rawBytes ? rawBytes.length : 0,
          timestamp: Date.now(),
          source: 'image'
        }
        console.log('Decoded from image:', payload)
        alert(`Scanned (image): ${payload.text} | format: ${payload.format} | bytes: ${payload.rawBytesLength}`)
      } catch (e) {
        console.error('Image decode error:', e)
        alert('Impossibile decodificare il codice dalla foto. Riprova con un\'altra immagine o più luce.')
      }
    },

    
    isComponentVisible(componentId) {
      const componentConfig = this.$store.getters.getObject(componentId);
      if (!componentConfig || !componentConfig.data) return true;
      
      if (!componentConfig.data.visibilityControl) return true;
      
      // Ottieni i dati del record corrente
      const recordData = this.$store.getters.getRecordData;
      if (!recordData) return false;
      
      // Verifica le condizioni di visibilità
      try {
        if (Array.isArray(componentConfig.data.visibilityControl)) {
          const operator = componentConfig.data.visibilityOperator || 'OR';
          
          if (operator.toUpperCase() === 'AND') {
            return componentConfig.data.visibilityControl.every(condition => {
              return this.checkVisibilityCondition(condition, recordData);
            });
          } else {
            return componentConfig.data.visibilityControl.some(condition => {
              return this.checkVisibilityCondition(condition, recordData);
            });
          }
        } 
        else if (componentConfig.data.visibilityControl.controlField) {
          return this.checkVisibilityCondition(componentConfig.data.visibilityControl, recordData);
        }
      } catch (error) {
        console.error('Errore nella verifica della visibilità del componente:', error);
        return false;
      }
      
      return true;
    },
    
    checkVisibilityCondition(condition, recordData) {
      if (!condition.controlField) return true;
      
      const controlField = condition.controlField;
      const expectedValues = condition.value;
      
      let currentValue;
      
      // Gestisce campi relazionali come "Categoria_caso__r. "
      if (controlField.includes('.')) {
        const parts = controlField.split('.');
        let value = recordData;
        for (const part of parts) {
          if (value && value[part]) {
            value = value[part];
          } else {
            return false;
          }
        }
        currentValue = value;
      } else {
        currentValue = recordData[controlField];
      }
      
      if (Array.isArray(expectedValues)) {
        return expectedValues.includes(currentValue);
      } else {
        return currentValue === expectedValues;
      }
    }
  }
}
</script>

<style scoped>
.scanner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  background: transparent;
}
.scanner-box {
  margin: 8px auto;
  padding: 8px;
  width: 96%;
  max-width: 640px;
  background: var(--bulma-background, #fff);
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.25);
}
.scanner-box :deep(video.video-preview) {
  max-height: 35vh;
}
.close-btn { position: absolute; right: 8px; top: 8px; opacity: 0.9; }
.close-btn:hover { opacity: 1; }
.capture-btn { position: absolute; left: 8px; top: 8px; }
</style>
